import { Loading, Text, Cup } from "./styles";

const Component = ({}) => {
  return (
    <Loading>
      <Cup />
    </Loading>
  );
};

export default Component;
